module.exports = __webpack_public_path__ + "img/founder5.8a4da366.jpg";